/* __next_internal_client_entry_do_not_use__ LazyPromoBanner auto */ import { jsx as _jsx } from "react/jsx-runtime";
import { Decorative } from "@faire/design-tokens";
import { Row } from "@faire/web--source/slate/Layout";
import { LoadingSpinner } from "@faire/web--source/slate/LoadingSpinner/LoadingSpinner";
import { GLOBAL_BANNER_COPY_120424 } from "@faire/web-api--source/indigofair/settings/GLOBAL_BANNER_COPY_120424";
import React, { lazy, Suspense } from "react";
import { isIdentityVerificationModalOrRoute } from "@faire/retailer/components/App/AppModals/utils";
import { useIsLoggedInRetailer } from "@faire/retailer/lib/isLoggedInRetailer";
import { isMobileApp } from "@faire/retailer/lib/isMobileApp";
import { useIsSemDiscoverPage } from "@faire/retailer/lib/useIsSemDiscoverPage";
import { useEffectAssignWhen } from "@faire/retailer/settings/useEffectAssignWhen";
import { useSettingGlobalBannerCopy } from "@faire/retailer/settings/useSettingGlobalBannerCopy";
import { usePromoBanners } from "@faire/retailer/stores/ui/usePromoBanners";
export var LazyPromoBanner = function() {
    var _usePromoBanners = usePromoBanners(), isPromoBannerVisible = _usePromoBanners.isVisible;
    var isSemDiscoverPage = useIsSemDiscoverPage();
    var isBannerlessVariant = useSettingGlobalBannerCopy().isBannerlessVariant;
    var isLoggedInRetailer = useIsLoggedInRetailer();
    useEffectAssignWhen(GLOBAL_BANNER_COPY_120424, !isLoggedInRetailer);
    if (isSemDiscoverPage || !isPromoBannerVisible || isMobileApp() && isIdentityVerificationModalOrRoute() || isBannerlessVariant) {
        return null;
    }
    return /*#__PURE__*/ _jsx(Suspense, {
        fallback: /*#__PURE__*/ _jsx(Row, {
            justify: "center",
            align: "center",
            style: {
                height: "36px",
                backgroundColor: Decorative.tint.neutral
            },
            children: /*#__PURE__*/ _jsx(LoadingSpinner, {
                "data-test-id": "faire-promo-spinner",
                size: "small"
            })
        }),
        children: /*#__PURE__*/ _jsx(LazyPromoBannerBase, {})
    });
};
var LazyPromoBannerBase = /*#__PURE__*/ lazy(function() {
    return import(/* webpackChunkName: "retailer-promo-banner" */ "./PromoBanner").then(function(m) {
        return {
            default: m.PromoBanner
        };
    });
});
